export const factions = [
    {
        title: "Samogitian kingdom",
        text:`Is a confederation of the most diverse peoples combined around one person.
        The GrandMaster. The oldest human in the galaxy.
        He was on Earth before it disappeared. And He knows what will be with his soul after death`,
        id: 1,
        color: '#FFFFFF' 
    },
    {
        title: "Caliphate",
        text: `The youngest galaxy state. Based on the cult of science and cognition.
        The Caliphate is managed by artificial intelligence of digitized consciousness of their prophet`,
        id: 2,
        color: '#DCAD51' 
    },
    {
        title: "Ruthenia",
        text: `The most mysterious faction.
        Lords of Ruthenia honored traditions of Void Gods cults.
        Morower, most of the ruins of abandoned temple complexes
        of extinct alien civilizations are here in Ruthenia`,
        id: 3,
        color: '#519765' 
    },
    {
        title: "Nomads",
        text: `The most militant faction.Each representative is a warrior.
        Descendants of warriors of the Solar system before Earth disappeared with surrounding space.
        They are searching for vengeance. They are searching for a home`,
        id: 4,
        color: '#BF2D2D' 
    },
    {
        title: "Last romans",
        text: `State that possesses Old Earth legacy. Ancient technologies allow others to be condescending.
        But there is a problem that everybody wants to get this legacy`,
        id: 5,
        color: '#EC9C6F' 
    },
    {
        title: "Varangians",
        text: `Descendants of the last pioneers. The worst planets
        were colonized by the last one. But harsh living conditions raise brave people.
        Varangians are the best bodyguards in the galaxy`,
        id: 6,
        color: '#568CD3' 
    },
]